// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CepEnderecoController from "./cep_endereco_controller"
application.register("cep-endereco", CepEnderecoController)

import CondicaoController from "./condicao_controller"
application.register("condicao", CondicaoController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DashboardFluxoController from "./dashboard_fluxo_controller"
application.register("dashboard-fluxo", DashboardFluxoController)

import DatatablesController from "./datatables_controller"
application.register("datatables", DatatablesController)

import DatetimepickerController from "./datetimepicker_controller"
application.register("datetimepicker", DatetimepickerController)

import DrawflowController from "./drawflow_controller"
application.register("drawflow", DrawflowController)

import FaseModalController from "./fase_modal_controller"
application.register("fase-modal", FaseModalController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FluxosController from "./fluxos_controller"
application.register("fluxos", FluxosController)

import InputmaskController from "./inputmask_controller"
application.register("inputmask", InputmaskController)

import ModeloFluxoFormController from "./modelo_fluxo_form_controller"
application.register("modelo-fluxo-form", ModeloFluxoFormController)

import NestedRondoController from "./nested_rondo_controller"
application.register("nested-rondo", NestedRondoController)

import NotificacoesController from "./notificacoes_controller"
application.register("notificacoes", NotificacoesController)

import UfMunicipioController from "./uf_municipio_controller"
application.register("uf-municipio", UfMunicipioController)
